import axios from "axios";
import { AppDispatch } from "../store"; // Import your Redux store types
import {
  FETCH_SAVED_CARDS,
  FETCH_SAVED_CARDS_SUCCESS,
  FETCH_SAVED_CARDS_FAILURE,
  SAVE_CARD,
  SAVE_CARD_SUCCESS,
  // SAVE_CARD_FAILURE,
  PROCESS_PAYMENT,
  PROCESS_PAYMENT_SUCCESS,
  PROCESS_PAYMENT_FAILURE,
} from "../types/StripeCardTypes";

// Backend API Base URL (Update with your actual backend API URL)
const API_PREFIX = "/stripe";

/**
 * Fetch Saved Cards from Stripe
 */
const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const fetchSavedCards = () => async (dispatch: AppDispatch) => {
  dispatch({ type: FETCH_SAVED_CARDS });

  try {
    const response = await API.get(`${API_PREFIX}/saved-cards`, {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`}});
    dispatch({ type: FETCH_SAVED_CARDS_SUCCESS, payload: response.data.data[0] ?? [] });
  } catch (error: any) {
    dispatch({
      type: FETCH_SAVED_CARDS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch saved cards",
    });
  }
};

/**
 * Save a New Card to Stripe
 */
export const saveCard = (paymentMethodId: string, onCardSaved: (paymentMethodId: string) => void) => async (dispatch: AppDispatch) => {
  dispatch({ type: SAVE_CARD });

  try {
    const response = await API.post(`${API_PREFIX}/save-card`, { paymentMethodId, }, {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`}});
    dispatch({ type: SAVE_CARD_SUCCESS, payload: response.data.data });
    dispatch(onCardSaved(paymentMethodId));
    dispatch(fetchSavedCards()); // Refresh saved cards after adding a new one
  } catch (error: any) {
    // dispatch({
    //   type: SAVE_CARD_FAILURE,
    //   payload: error.response?.data?.message || "Failed to save card",
    // });
  }
};

/**
 * Process Payment Using a Saved Card
 */
export const processPayment = (bookingId: string, paymentMethodId: string) => async (dispatch: AppDispatch) => {
  dispatch({ type: PROCESS_PAYMENT });

  try {
    const response = await API.post(`${API_PREFIX}/process-payment`, { bookingId, paymentMethodId }, {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`}});
    dispatch({ type: PROCESS_PAYMENT_SUCCESS, payload: response.data });
    // Navigate to payment success page with session ID
    if (response.data?.data?.session_id) {
      window.location.href = `/payment/success?session_id=${response.data.data.session_id}`;
    }
  } catch (error: any) {
    dispatch({
      type: PROCESS_PAYMENT_FAILURE,
      payload: error.response?.data?.message || "Payment failed",
    });
    window.location.href = `/payment/cancel`;

  }
};

/**
 * Create Setup Intent for Stripe
 */
export const createSetupIntent = () => async (dispatch: AppDispatch) => {
  dispatch({ type: 'CREATE_SETUP_INTENT' });

  try {
    const response = await API.post(
      `${API_PREFIX}/create-setup-intent`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }}
    );
    
    dispatch({ 
      type: 'CREATE_SETUP_INTENT_SUCCESS', 
      payload: response.data.data.client_secret 
    });
    
    return response.data.data.client_secret;
  } catch (error: any) {
    dispatch({
      type: 'CREATE_SETUP_INTENT_FAILURE',
      payload: error.response?.data?.message || "Failed to create setup intent"
    });
    throw error;
  }
};

